// Module
var code = "<sb-app-checklist-template-list-page></sb-app-checklist-template-list-page> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/checklistTemplates/states/qaList/qa_list.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;